import { createContext, useContext } from "react";

export const UNKNOWN_LIST_NAME = 'Unknown list'

export const ListNameContext = createContext(UNKNOWN_LIST_NAME);

export const useProductListName = () => useContext(ListNameContext);